export default __webpack_public_path__ + "static/part3_2-d6c339ce8481f63f4f288bad5a7ade6c.png";